<template>
  <section class="section-base section-color">
    <div class="container">
      <div class="row" data-anima="fade-bottom" data-time="1000">
        <div class="col-lg-6">
          <div class="title">
            <h2>COMO FUNCIONA?</h2>
            <p>NOSSA PLATAFORMA DE VENDAS</p>
          </div>
        </div>
        <div class="col-lg-6 align-right align-left-md">
          <hr class="space-sm hidden-md"/>
          <a href="https://painel.skysolar.com.br/precadastro" class="btn-text active">Realizar
            Pré-Cadastro</a>
        </div>
      </div>
      <hr class="space"/>
      <div class="box-steps" data-anima="fade-bottom" data-time="1000">
        <div class="step-item">
          <span>1</span>
          <div class="content">
            <h3>Pré-Cadastro</h3>
            <div>
              <p>
                Você, Pessoa Jurídica do ramo de energia fotovoltaica, realiza um pré-cadastro em
                nossa plataforma <a href="https://painel.skysolar.com.br/precadastro">clicando
                aqui</a>. Após preencher os dados, aguarde a aprovação que pode levar de 12-72h.
              </p>
            </div>
          </div>
        </div>
        <div class="step-item">
          <span>2</span>
          <div class="content">
            <h3>Aprovação</h3>
            <div>
              <p>
                Após o seu cadastro ser aprovado, você receberá os dados para acesso via e-mail.
              </p>
            </div>
          </div>
        </div>
        <div class="step-item">
          <span>3</span>
          <div class="content">
            <h3>Acesso a Plataforma</h3>
            <div>
              <p>
                Na plataforma, você terá acesso a toda a documentação dos equipamentos, preços,
                contratos e canais de atendimento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComoFunciona',
};
</script>

<style scoped>
main > section > .container {
  padding-top: 0 !important;
}
.section-base {
  margin-top: -100px !important;
}
</style>
